var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('v-text-field',{staticClass:"text-center",attrs:{"value":_vm.service.availableQuantity,"flat":"","hide-details":""},on:{"change":_vm.changeRoomAvailability}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }